import { Info } from "lucide-react";
import React from "react";
import { Tooltip } from "react-tooltip";

export default function MyTooltip({
  msg = [],
  tpId = "0",
  icon,
  color,
  border,
}) {
  const Icon = icon ?? Info;
  return (
    <>
      <Icon
        className="text-slate-800 dark:text-slate-500 cursor-alias"
        size={16}
        data-tooltip-id={tpId}
        style={color && { color: color }}
      />

      <Tooltip
        className={`!bg-slate-200 dark:!bg-slate-800 !text-slate-600 dark:!text-slate-200 !rounded-lg  `}
        id={tpId}
        noArrow={true}
        style={{
          padding: "8px 12px",
          margin: "4px",
          borderRadius: "100px",
          "--rt-arrow-size": "0px",
        }}
        place="top"
        render={() => (
          <div className={`${border && "rounded-lg p-2 border-" + border}  `}>
            {msg.map((item, i) =>
              item ? (
                <p className="text-[10px]" key={i}>
                  {item}
                </p>
              ) : (
                <br key={i} />
              ),
            )}
          </div>
        )}
      />
    </>
  );
}
